import { strings, stringKeys } from "../../../strings";

export const agreementsSiteMap = [
  {
    path: "/agreements",
    title: () => strings(stringKeys.nationalSocietyConsents.title),
  },
];
